"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNumberOfFilledPrintables;
const Project_1 = require("../../models/Project");
const getEmptyUserPhotoLayers_1 = require("./getEmptyUserPhotoLayers");
function getNumberOfFilledPrintables(project) {
  return (0, Project_1.getNumPrintablesInProject)(project) - (0, getEmptyUserPhotoLayers_1.getEmptyUserPhotoLayers)(project).length;
}